import { PLAYER_ASSISTS_CATEGORY, PLAYER_HEADSHOTS_CATEGORY } from 'app/constants/markets';

interface MarketGroupDefinition {
  category: string;
  label: string;
  mainSlugs: string[];
  eventsWithSupremacy: BlueprintEventType[];
  eventsWithTotals: BlueprintEventType[];
  videogamesWithSupremacy: VideogameSlug[];
  videogamesWithTotals: VideogameSlug[];
}
const marketGroupsDef: MarketGroupDefinition[] = [
  {
    category: 'winner',
    label: 'Winner',
    mainSlugs: [
      'winner-2-way',
      'winner-3-way',
      'winner-3-way-exclude-overtime',
      'winner-2-way-draw-no-bet',
      'outright-winner' // for Outrights blueprints
    ],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: [
      'league-of-legends',
      'cs-go',
      'dota-2',
      'ow',
      'rl',
      'cod-mw',
      'r6-siege',
      'fifa',
      'valorant',
      'kog',
      'lol-wild-rift',
      'starcraft-2',
      'starcraft-brood-war',
      'mlbb'
    ],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'main',
    label: 'Main',
    mainSlugs: [
      'map-handicap',
      'map-handicap-1',
      'map-handicap-2',
      'map-handicap-3',
      'map-handicap-4',
      'map-over-under'
    ],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: [],
    eventsWithTotals: ['match'],
    videogamesWithTotals: ['league-of-legends', 'dota-2', 'cs-go']
  },
  {
    category: 'kill',
    label: 'Kills',
    mainSlugs: ['kill-handicap', 'kill-over-under'],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: ['league-of-legends', 'dota-2'],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['league-of-legends', 'dota-2']
  },
  {
    category: 'kill_between_time_window',
    label: 'Micromarkets',
    mainSlugs: ['kill-most-2-way-between-time-window', 'kill-most-3-way-between-time-window'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'tower',
    label: 'Towers',
    mainSlugs: ['tower-handicap', 'tower-over-under'],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: ['league-of-legends', 'dota-2'],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['league-of-legends', 'dota-2']
  },
  {
    category: 'drake',
    label: 'Drakes',
    mainSlugs: ['drake-handicap', 'drake-over-under'],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: ['league-of-legends'],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['league-of-legends']
  },
  {
    category: 'nashor',
    label: 'Nashors',
    mainSlugs: ['nashor-handicap', 'nashor-over-under'],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: ['league-of-legends'],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['league-of-legends']
  },
  {
    category: 'inhibitor',
    label: 'Inhibitors',
    mainSlugs: ['inhibitor-handicap', 'inhibitor-over-under'],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: ['league-of-legends'],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['league-of-legends']
  },
  {
    category: 'atakhan',
    label: 'Atakhan',
    mainSlugs: ['atakhan-first'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'round',
    label: 'Rounds',
    mainSlugs: ['round-handicap', 'round-over-under', 'round-winner-2-way'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['cs-go', 'valorant']
  },
  {
    category: 'round_pistol',
    label: 'Pistol Rounds',
    mainSlugs: ['round-pistol-n-winner'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'barrack',
    label: 'Barracks',
    mainSlugs: ['barrack-handicap', 'barrack-over-under'],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: ['dota-2'],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['dota-2']
  },
  {
    category: 'roshan',
    label: 'Roshans',
    mainSlugs: ['roshan-handicap', 'roshan-over-under'],
    eventsWithSupremacy: ['game'],
    videogamesWithSupremacy: ['dota-2'],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['dota-2']
  },
  {
    category: 'goal',
    label: 'Goal (exc. OT)',
    mainSlugs: ['kill-handicap', 'kill-over-under'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['rl']
  },
  {
    category: 'player',
    label: 'Players',
    mainSlugs: ['kill-over-under'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: ['cs-go']
  },
  {
    category: PLAYER_ASSISTS_CATEGORY,
    label: 'Players assists',
    mainSlugs: ['player-assist-over-under'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: ['league-of-legends']
  },
  {
    category: PLAYER_HEADSHOTS_CATEGORY,
    label: 'Players headshots',
    mainSlugs: ['player-headshot-over-under'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'player_matchups',
    label: 'Players - Matchup',
    mainSlugs: ['player_matchups'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: ['cs-go']
  },
  {
    category: 'player_fixed_line',
    label: 'Players - Fixed Lines',
    mainSlugs: ['player_fixed_line'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: ['cs-go']
  },
  {
    category: 'point',
    label: 'Points',
    mainSlugs: ['point-handicap', 'point-over-under'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'run',
    label: 'Runs',
    mainSlugs: ['run-over-under', 'run-participant-over-under', 'run-odd-even'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'wicket',
    label: 'Wickets',
    mainSlugs: ['wicket-over-under'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'timer',
    label: 'Timer',
    mainSlugs: ['timer-over-under'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: ['game'],
    videogamesWithTotals: ['dota-2']
  },
  {
    category: 'micro',
    label: 'Micromarkets',
    mainSlugs: [],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'prebuilt',
    label: 'Pre-built',
    mainSlugs: [
      'prebuilt-game-winner-and-player-kill-over',
      'prebuilt-game-winner-and-player-kill-under'
    ],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  },
  {
    category: 'prebuilt-storybuilder',
    label: 'Story Builder',
    mainSlugs: ['prebuilt-storybuilder'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  }
];

// For Outrights, we're gonna use the same structure to keep it simple, but make it work in a different way
// Category and label will be the "displayed" category we want on the blueprint page
// Main Slugs will be the market templates that will belong to the group
const outrightsGroupsDefs: MarketGroupDefinition[] = [
  {
    category: 'outright-winner-test',
    label: 'Winner',
    mainSlugs: ['outright-winner'],
    eventsWithSupremacy: [],
    videogamesWithSupremacy: [],
    eventsWithTotals: [],
    videogamesWithTotals: []
  }
];

export { marketGroupsDef, outrightsGroupsDefs };
export type { MarketGroupDefinition };
